<template>
<div class="rows is-full-height is-gapless">
  <div
  class="row is-narrow table-header"
  ref="tableHeader">
    <table>
      <thead>
        <tr v-no-select>
          <th class="col_tool left">
            <v-checkbox
            :value='all_selected'
            @input="onSelectAll($event)"
            filled class="text-xs-center"></v-checkbox>
          </th>
          <th class="v-sortable"
          v-for="(header, index) in headers"
          v-if="header.display"
          :name="header.id"
          :key="header.id"
          :class="{
            'col_id': header.id === 'id',
            'v-sorted': header.sorted,
            'v-sorted-descending': header.descending
          }"
          @click="onColSort(header)">
              <span v-html="header.text"></span>
              <i class="arrow_downward"></i>
          </th>
          <th class="col_tool right">
          </th>
          <th style="max-width: 16px"></th>
        </tr>
      </thead>
    </table>
  </div>
  <div class="row is-full-height" ref="table_scroll">
    <div class="table-body"
    ref="tableBody"
    v-tableFix:tableHeader>
      <table class="tbody"
      style="margin-top: 0;">
        <transition-group 
        name="vfade"
        tag="tbody">
          <template
          v-for="(item, index) in items">
            <slot
            :keyField="keyField"
            class="item"
            :index="index"
            :item="item"></slot>
          </template>
        </transition-group>
      </table>
    </div>
  </div>
</div>
</template>
<script>

export default {
  props: {
    headers: Array,
    items: Array,
    all_selected: Boolean,
    keyField: {
      default: 'id',
      type: String
    }
  },

  data: () => ({
  }),

  directives: {
    tableFix: {
      componentUpdated: function (el, directive, vnode) {
        var vm = vnode.context
        vm.$nextTick(function () {
          var ref = directive.arg
          var target = vm.$refs[ref]
          vm.tableFix(el, target, false)
        })
      }
    }
  },
  methods: {
    tableFix: function (source, target, doubleCheck) {
      var tableBoby = source.querySelector('table')
      var tableHeader = target.querySelector('table')
      var headersSource = source.querySelectorAll('tr:first-child td')
      var headersTarget = target.querySelectorAll('th')
      var tableHeaderHeight = parseInt(tableHeader.offsetHeight)
      var width
      var i
      var len = headersSource.length

      // tableBoby.style.marginTop = -tableHeaderHeight + 'px'

      for (i = 0; i < len; i++) {
        width = parseInt(headersSource[i].offsetWidth)
        headersTarget[i].style.width = width + 'px'
      }

      // this.$refs.tableBody.scrollTop = 0
    },

    scrollToTop: function (selected) {
      this.$refs.tableBody.scrollTop = 0
    },

    onSelectAll: function (selected) {
      this.$emit('selectAll', selected)
    },

    onItemSelect: function (item, selected) {
      this.$emit('select', {item, selected})
    },

    onColSort: function (header) {
      this.$emit('colSort', header)
    },

    onEdit: function (contact_id) {
      this.$emit('edit', contact_id)
    }

  }
}
</script>
<style>

table {
  table-layout: fixed;
}

.table-body {
  overflow: auto;
  height: 100%;
  width: 100%;
}

.table-header > table {
  border-bottom: 1px solid #ddd;
  background-color: #f9f7f7;
}

.table-header {
  position: relative;
}

#col_dropdown {
  float: right;
  display: inline-block;
  z-index: 99;
}

.no_display_id th[name='ID'],
.no_display_id td[name='ID'] {
  display: none;
}

</style>
